"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Subtitle2Stronger: function() {
        return _index.Subtitle2Stronger;
    },
    subtitle2StrongerClassNames: function() {
        return _index.subtitle2StrongerClassNames;
    }
});
const _index = require("./components/presets/Subtitle2Stronger/index");
